//#region src/compat/function/identity.ts
function identity(x) {
	return x;
}
//#endregion
export { identity };
